import type { Currency } from './currency';

export type { Currency };

/** "USD 1,550" */
/** An amount with its currency, or a dash while the vault has no price yet */
export const moneyOrDash = (n: number, currency: Currency) => (n > 0 ? money(n, currency) : '–');

export const money = (n: number, currency: Currency) => `${currency} ${Math.round(n).toLocaleString('en-US')}`;

/** Profit as a share of the selling price: "10.8%" */
export const margin = (sell: number, cost: number) =>
  sell > 0 ? `${(((sell - cost) / sell) * 100).toFixed(1)}%` : '—';

/** "1,267.83" */
export const amount = (n: number) => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
